export const common = {
  nav: {
    home: 'Startseite',
    about: 'Über uns',
    rooms: 'Zimmer',
    gallery: 'Galerie',
    reservation: 'Reservierung',
    access: 'Anfahrt',
    contact: 'Kontakt',
    forOwners: 'Für Eigentümer',
    freeConsultation: 'Kostenlose Beratung',
  },
  hero: {
    title: 'Wo Tradition auf',
    subtitle: 'modernen Komfort trifft',
    description: 'Erleben Sie den authentischen Charme eines traditionellen japanischen Hauses in Magome, Ota-ku, Tokyo. Eine perfekte Verbindung aus historischer Schönheit und zeitgemäßem Komfort.',
    bookNow: 'Jetzt buchen',
    viewGallery: 'Galerie ansehen',
  },
  about: {
    title: 'Über uns',
    subtitle: 'Eine harmonische Verbindung aus traditioneller japanischer Architektur und modernem Komfort',
    description: 'Das Traditionelle Haus Magome ist ein wunderschön restauriertes japanisches Haus im ruhigen Wohnviertel Magome, Ota-ku, Tokyo. Sorgfältig renoviert, um seinen traditionellen Charme zu bewahren und gleichzeitig modernen Komfort zu bieten, ermöglicht es ein einzigartiges Erlebnis des authentischen japanischen Lebens.',
    feature1Title: 'Ganzes Haus',
    feature1Desc: 'Genießen Sie vollständige Privatsphäre mit Ihrer Familie und Freunden in dieser exklusiven Unterkunft',
    feature2Title: 'Vollständige Küche',
    feature2Desc: 'Voll ausgestattete Küche zur Zubereitung Ihrer Lieblingsgerichte',
    feature3Title: 'Bis zu 8 Gäste',
    feature3Desc: 'Geräumige Unterkunft, ideal für Gruppen und Familien',
    feature4Title: 'Traditionelle Tatami',
    feature4Desc: 'Authentische japanische Zimmer mit Tatami-Matten und Holzwärme',
  },
  rooms: {
    title: 'Zimmer',
    subtitle: 'Entspannen Sie in traditionellen japanischen Räumen',
    room1: 'Grundriss',
    room2: 'Vollständige Küche',
    room3: 'Einfaches Bett',
    capacity: 'Maximale Kapazität',
    guests: '8 Gäste',
    amenities: 'Ausstattung',
    amenitiesList: 'Vollständige Küche, Kühlschrank, Mikrowelle, Kochutensilien, Geschirr, WLAN, Klimaanlage, Heizung, Waschmaschine, Badezimmer, Toilette, Handtücher, Toilettenartikel',
  },
  gallery: {
    title: 'Galerie',
    subtitle: 'Entdecken Sie die Schönheit des Traditionellen Hauses Magome',
  },
  reservation: {
    title: 'Reservierung',
    subtitle: 'Buchen Sie Ihren besonderen Aufenthalt',
    name: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    checkin: 'Check-in',
    checkout: 'Check-out',
    guests: 'Anzahl der Gäste',
    message: 'Besondere Wünsche',
    submit: 'Reservierungsanfrage senden',
    submitting: 'Wird gesendet...',
    success: 'Ihre Reservierungsanfrage wurde erhalten. Wir werden uns in Kürze bei Ihnen melden.',
    error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    bookingPlatforms: 'Sie können auch über diese Plattformen buchen',
    bookOnAirbnb: 'Verfügbarkeit prüfen & auf Airbnb buchen',
    bookOnJalan: 'Verfügbarkeit prüfen & auf Jalan buchen',
    orDirectBooking: 'oder kontaktieren Sie uns direkt',
    required: 'Pflichtfeld',
    guestsPlaceholder: '― Bitte auswählen ―',
    guestSingular: 'Gast',
    guestPlural: 'Gäste',
    messagePlaceholder: 'Besondere Wünsche oder Fragen? Schreiben Sie uns. (max. 500 Zeichen)',
    confirmNote: '※ Wir melden uns nach Bestätigung Ihrer Anfrage.',
  },
  contact: {
    title: 'Kontakt',
    subtitle: 'Zögern Sie nicht, uns bei Fragen oder Anfragen zu kontaktieren',
    name: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    subject: 'Betreff',
    message: 'Nachricht',
    submit: 'Senden',
    submitting: 'Wird gesendet...',
    success: 'Ihre Nachricht wurde erhalten. Wir werden uns in Kürze bei Ihnen melden.',
    error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    address: 'Adresse',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'Anfahrt',
    accessDetail: '8 Minuten zu Fuß vom Bahnhof Magome (Toei Asakusa Linie)',
    faqBannerTitle: 'Bitte prüfen Sie vor dem Absenden unsere FAQ',
    faqBannerDesc: 'Wir haben bereits viele häufige Fragen zu Preisen, Verfahren und Verwaltung beantwortet.',
    faqBannerBtn: 'FAQ ansehen',
    accessInfoTitle: 'Anfahrtsinformationen',
    sendMessageTitle: 'Nachricht senden',
    inquiryType: 'Anfragetyp',
    inquiryTypePlaceholder: 'Anfragetyp auswählen',
    inquiryOptions: {
      minpaku: 'Minpaku-Registrierung / Genehmigungsantrag',
      ryokan: 'Ryokan-Lizenzerwerb',
      management: 'Immobilienverwaltung / Betrieb',
      pricing: 'Preise / Pläne',
      marketing: 'Airbnb-Inserat / Marketing',
      revenue: 'Umsatzsimulation',
      other: 'Sonstiges',
    },
    messagePlaceholder: 'Bitte beschreiben Sie Ihre Anfrage (max. 500 Zeichen)',
    detailLabel: 'Beratungsdetails',
    detailPlaceholder: 'Bitte beschreiben Sie Lage, aktuellen Zustand und Ihre Wünsche (max. 500 Zeichen)',
  },
  access: {
    label: 'Anfahrt',
    title: 'Anfahrt & Karte',
    subtitle: 'Im ruhigen Wohnviertel Higashi-Magome, Ota-ku, Tokyo gelegen',
    addressLabel: 'Adresse',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'Mit der Bahn',
    trainLine1: '2 Min. zu Fuß vom Bahnhof Magome (Toei Asakusa Linie)',
    trainLine2: '',
    busLabel: 'Mit dem Bus',
    busLine1: '2 Min. zu Fuß von der Bushaltestelle "Magome Ekimae" (Toei Bus)',
    busLine2: '',
    parkingLabel: 'Parken',
    parkingLine1: 'Münzparkplätze in der Nähe verfügbar',
    parkingLine2: 'Bitte kontaktieren Sie uns, wenn Sie mit dem Auto anreisen',
    openMap: 'In Google Maps öffnen',
  },
  footer: {
    description: 'Vermietung eines traditionellen japanischen Hauses in Magome, Ota-ku, Tokyo. Erleben Sie die perfekte Harmonie aus japanischer Schönheit und modernem Komfort.',
    quickLinks: 'Schnelllinks',
    followUs: 'Folgen Sie uns',
    rights: 'Alle Rechte vorbehalten.',
    napTitle: 'Yokota Steuer- & Buchhaltungsbüro',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'Tel.: Bitte kontaktieren Sie uns',
    napServiceArea: 'Servicegebiet: Ota City und Groß-Tokyo',
    napAccess: 'Toei Asakusa Linie — Bahnhof Magome',
  },
  stickyButton: {
    title: 'Kostenlose',
    subtitle: '30-Min-Beratung',
  },
  ownersBanner: {
    subtitle: 'Für Eigentümer, die Airbnb in Tokyo in Betracht ziehen',
    linkText: 'Mehr über unsere Unterstützungsleistungen für Eigentümer erfahren →',
  },
  airbnbLead: {
    title: 'Möchten Sie Airbnb in Tokyo starten?',
    description: 'Wir bieten umfassende Unterstützung — von der Minpaku-Registrierung und dem Erwerb der Ryokan-Lizenz bis hin zur vollständigen Immobilienverwaltung. Mit Sitz in Ota City und echter Betriebserfahrung.',
    ctaButton: 'Kostenlose Beratung erhalten',
    badge1: 'Unverbindliche Beratung',
    badge2: 'Echte Betriebserfahrung',
    badge3: 'Vollständige Unterstützung von der Lizenz bis zur Verwaltung',
  },
  trust: {
    badge: 'Warum uns wählen',
    title: 'Vertrauen von Tokioter Immobilieneigentümern',
    subtitle: 'Wir kombinieren echte Betriebserfahrung mit umfassender Unterstützung, um Ihnen zum Erfolg zu verhelfen.',
    point1Title: 'Echte Airbnb-Erfahrung',
    point1Description: 'Wir betreiben aktiv unsere eigene traditionelle Unterkunft in Ota City. Unsere Ratschläge basieren auf praktischer Erfahrung, nicht auf Theorie.',
    point2Title: 'Vollständige Lizenzunterstützung',
    point2Description: 'Von der Minpaku-Registrierung bis zum Erwerb der Ryokan-Lizenz — wir kümmern uns um alle Unterlagen und Behördenkommunikation.',
    point3Title: 'Umsatzoptimierung',
    point3Description: 'Datengesteuerte Preisstrategien basierend auf echten Tokioter Marktdaten. Durchschnittlich über 30% Umsatzsteigerung für unsere Kunden.',
    point4Title: '24/7 Gästebetreuung',
    point4Description: 'Rund-um-die-Uhr mehrsprachige Gästekommunikation, damit Sie sich auf Ihre Einnahmen konzentrieren können.',
    point5Title: 'Transparente Berichte',
    point5Description: 'Monatliche Umsatzberichte und klare Gebührenstrukturen. Keine versteckten Kosten, keine Überraschungen.',
    ctaButton: 'Unsere Dienstleistungen entdecken',
  },
  howItWorks: {
    title: 'So funktioniert es',
    subtitle: 'Ein einfacher, transparenter Prozess von der Beratung bis zum erfolgreichen Start',
    step1Number: '01',
    step1Title: 'Kostenlose Beratung',
    step1Desc: 'Teilen Sie uns Ihre Immobiliendetails und Ziele mit. Wir geben ehrliche Ratschläge zu Lizenzen, Umsatzpotenzial und nächsten Schritten.',
    step2Number: '02',
    step2Title: 'Immobilienbewertung',
    step2Desc: 'Wir bewerten die Eignung Ihrer Immobilie, identifizieren Anforderungen und erstellen einen maßgeschneiderten Aktionsplan.',
    step3Number: '03',
    step3Title: 'Start & Unterstützung',
    step3Desc: 'Von der Lizenzbeantragung bis zur Gästeverwaltung kümmern wir uns um alles, damit Sie sich auf Ihre Einnahmen konzentrieren können.',
    ctaButton: 'Kostenlose Beratung buchen',
    ctaNote: '30 Minuten • Unverbindlich • Klarer Fahrplan',
  },
  urgency: {
    title: 'Möchten Sie Airbnb in Tokyo starten?',
    description: 'Lizenzregeln sind komplex und Fehler können Ihren Start verzögern. Holen Sie sich klare, praktische Ratschläge, bevor Sie Entscheidungen treffen.',
    ctaButton: 'Kostenlose Beratung buchen',
    note: '30-Minuten-Beratung • Unverbindlich • Echte Erfahrung',
  },
  trustRisk: {
    title: 'Beratung ohne Druck',
    description: 'Wir geben praktische Ratschläge basierend auf echter Erfahrung. Auch wenn Sie sich entscheiden, nicht fortzufahren, erhalten Sie einen klaren Fahrplan.',
    badge1Title: 'Unverbindlich',
    badge1Desc: 'Kostenlose Beratung ohne Druck',
    badge2Title: 'Echte Erfahrung',
    badge2Desc: 'Wir betreiben unsere eigene Immobilie',
    badge3Title: 'Klarer Fahrplan',
    badge3Desc: 'Umsetzbare Anleitung, die Sie nutzen können',
    whatYouGetTitle: 'Was Sie aus unserer Beratung mitnehmen',
    item1: 'Ehrliche Einschätzung des Potenzials Ihrer Immobilie',
    item2: 'Klare Erklärung der Lizenzanforderungen und des Zeitplans',
    item3: 'Realistische Umsatzprognosen basierend auf Ihrem Standort',
    item4: 'Schritt-für-Schritt-Fahrplan, den Sie eigenständig umsetzen können',
    ctaButton: 'Kostenlose Beratung planen',
    ctaNote: 'Verfügbar Montag–Freitag, 9:00–18:00 Uhr JST',
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    subtitle: 'Häufige Fragen zum Start und Betrieb von Airbnb und Minpaku in Tokyo',
    ctaText: 'Haben Sie weitere Fragen? Wir helfen Ihnen gerne.',
    ctaButton: 'Kostenlose Beratung buchen',
    q1: 'Wie starte ich Airbnb in Tokyo?',
    a1: 'Um Airbnb in Tokyo zu starten, benötigen Sie eine entsprechende Lizenz. Sie haben zwei Hauptoptionen: Minpaku (Wohnunterkunft) Registrierung oder Ryokan (einfache Unterkunft) Lizenz. Minpaku erlaubt bis zu 180 Betriebstage pro Jahr und erfordert eine Registrierung bei den lokalen Behörden. Die Ryokan-Lizenz erlaubt ganzjährigen Betrieb, erfordert jedoch strengere Einrichtungsstandards und Brandschutzvorschriften.',
    q2: 'Was ist der Unterschied zwischen Minpaku und Ryokan-Lizenz?',
    a2: 'Minpaku (民泊) ist eine Wohnunterkunft-Registrierung, die Immobilieneigentümern erlaubt, ihre Häuser bis zu 180 Tage pro Jahr zu vermieten. Es hat einfachere Anforderungen, aber betriebliche Einschränkungen. Ryokan (簡易宿所) ist eine einfache Unterkunftslizenz, die ganzjährigen Betrieb ohne Tageslimits erlaubt. Es erfordert jedoch strengere Einrichtungsstandards, Brandschutzausrüstung und regelmäßige Inspektionen.',
    q3: 'Können Ausländer Airbnb in Japan starten?',
    a3: 'Ja, Ausländer können Airbnb-Geschäfte in Japan starten, aber es gibt wichtige Anforderungen. Sie müssen einen ordnungsgemäßen Aufenthaltsstatus haben, der Geschäftsaktivitäten in Japan erlaubt. Immobilieneigentum oder ein gültiger Mietvertrag ist erforderlich, und Sie müssen einen Verwaltungsvertreter benennen, der in Japan wohnt und innerhalb von 30 Minuten auf Probleme reagieren kann.',
    q4: 'Wie lange dauert die Minpaku-Registrierung in Tokyo?',
    a4: 'Die Minpaku-Registrierung in Tokyo dauert typischerweise 2–4 Monate von der ersten Vorbereitung bis zur Genehmigung. Der Zeitplan umfasst: Immobilienbewertung und -vorbereitung (2–3 Wochen), Dokumentenvorbereitung und Brandschutzinspektion (2–4 Wochen), Einreichung bei der Kommunalverwaltung (1–2 Wochen Bearbeitung) und endgültige Genehmigung und Registrierung (1–2 Wochen).',
    q5: 'Wie viel kostet der Start?',
    a5: 'Die Kosten variieren je nach Umfang der Dienstleistungen und dem Zustand Ihrer Immobilie. Wir bieten Pläne an, die Antragsunterstützung, Dokumentenvorbereitung und Vor-Ort-Bewertung umfassen. Für Immobilienverwaltungsdienstleistungen verwenden wir eine leistungsbasierte Gebührenstruktur — einen Prozentsatz des Umsatzes — damit Sie mit minimalen Vorabkosten starten können.',
    q6: 'Was können Sie übernehmen, wenn ich die Selbstverwaltung schwierig finde?',
    a6: 'Wir können alles übernehmen — Reservierungsverwaltung, Gästekommunikation, Reinigungskoordination, Schlüsselübergabe, Problemlösung und monatliche Umsatzberichte. Immobilieneigentümer können im Wesentlichen ein Airbnb ohne eigenen Aufwand betreiben.',
    q7: 'Kann ich Airbnb in einer Eigentumswohnung betreiben?',
    a7: 'Airbnb in einer Eigentumswohnung zu betreiben ist möglich, solange es nicht durch die Verwaltungsregeln des Gebäudes verboten ist. Sie müssen zunächst die Verwaltungsvorschriften prüfen, um zu bestätigen, dass es keine Klauseln gibt, die Unterkunfts- oder Kurzzeitvermietungsaktivitäten verbieten.',
    q8: 'Ich mache mir Sorgen über Beschwerden von Nachbarn. Wie gehen Sie damit um?',
    a8: 'Wir legen klare Hausregeln für Gäste fest (Lärm, Müllentsorgung, Nutzung von Gemeinschaftsbereichen usw.) und erklären sie beim Check-in sorgfältig, um Probleme zu verhindern. Wenn eine Beschwerde auftritt, haben wir ein 24-Stunden-Reaktionssystem, um die Situation schnell zu beurteilen und zu beheben.',
    q9: 'Wie viel Umsatz kann ich erwarten?',
    a9: 'Der Umsatz variiert erheblich je nach Lage, Größe, Ausstattung und Belegungsrate der Immobilie. In beliebten Tokioter Gebieten können 1LDK- bis 2LDK-Immobilien in einigen Fällen monatliche Einnahmen von 200.000–500.000 ¥ erzielen. Wir bieten eine kostenlose Umsatzsimulation basierend auf unseren vergangenen Betriebsdaten an.',
    q10: 'Ist es in Ordnung, nur zu beraten? Werde ich unter Druck gesetzt, einen Vertrag zu unterzeichnen?',
    a10: 'Absolut — Beratungen allein sind sehr willkommen. Wir drängen Sie nie dazu, sofort einen Vertrag zu unterzeichnen. Wir hoffen, dass Sie sich Zeit nehmen und in Ihrem eigenen Tempo eine Entscheidung treffen.',
  },
  seo: {
    home: {
      title: 'Magome Kominka | Traditionelles Japanisches Haus Tokyo & Airbnb Verwaltung',
      description: 'Übernachten Sie in einem traditionellen japanischen Haus in Magome, Ota-ku, Tokyo — Ganzhausmiete für bis zu 8 Personen. Professionelle Airbnb-Verwaltung und Minpaku-Lizenz-Support von aktiven Gastgebern.',
      keywords: 'Magome Kominka, Tokyo Airbnb, Ota City Minpaku, traditionelles japanisches Haus, Kurzzeitvermietung Tokyo',
    },
    management: {
      title: 'Airbnb Verwaltungsservice Tokyo | Vollständige Kurzzeitvermietung',
      description: 'Professionelle Airbnb-Verwaltung in Tokyo. Gästekommunikation, dynamische Preisgestaltung, Reinigungskoordination und monatliche Berichte. Vollständige Kurzzeitvermietungsverwaltung für Eigentümer in Ota City und Groß-Tokyo.',
      keywords: 'Airbnb Verwaltung Tokyo, Kurzzeitvermietung Tokyo, Immobilienverwaltung Ota City, Gästeservice Tokyo',
    },
    support: {
      title: 'Tokyo Minpaku & Ryokan Lizenz Support | Beherbergungsgewerbe Gründung',
      description: 'Expertenunterstützung für Minpaku-Registrierung und Ryokan-Lizenzantrag in Tokyo. Praxisnahe Begleitung von aktiven Gastgebern in Ota City — von der Bürokratie bis zum Umsatzstart.',
      keywords: 'Minpaku Registrierung Tokyo, Ryokan Lizenz Tokyo, Airbnb Support Tokyo, Kurzzeitvermietung Ota City',
    },
    forOwners: {
      title: 'Tokyo Airbnb Verwaltung & Minpaku Lizenz Support für Eigentümer',
      description: 'Vollständige Airbnb-Verwaltung und Minpaku-Lizenz-Support für Tokioter Immobilieneigentümer. Von der Lizenzierung bis zum täglichen Betrieb und Reinigung — kompletter Support. Kostenlose Erstberatung.',
      keywords: 'Tokyo Airbnb Eigentümer, Minpaku Lizenz Support, Immobilienverwaltung Tokyo, Airbnb Ota City',
    },
    pricing: {
      title: 'Airbnb Verwaltungspreise Tokyo | Transparente Pläne für Eigentümer',
      description: 'Klare, transparente Preise für Airbnb-Verwaltung und Minpaku-Support in Tokyo. Startunterstützung, Volleinrichtung, Verwaltungsservice und Reinigungspakete. Keine versteckten Kosten.',
      keywords: 'Airbnb Verwaltung Preise Tokyo, Minpaku Support Kosten, Kurzzeitvermietung Pläne Tokyo, Verwaltungsgebühr Tokyo',
    },
    minpakuRegistration: {
      title: 'Minpaku Registrierung Tokyo | Schritt-für-Schritt Ryokan Lizenz Leitfaden',
      description: 'Vollständiger Leitfaden zur Minpaku-Registrierung in Tokyo. Ryokan-Lizenzantragsprozess, erforderliche Dokumente, Zeitplan und häufige Fehler — basierend auf echter Betriebserfahrung in Ota City.',
      keywords: 'Minpaku Registrierung Tokyo, Ryokan Lizenz Tokyo, Airbnb Support Tokyo, Kurzzeitvermietung Ota City',
    },
    guide: {
      title: 'Tokyo Minpaku Startleitfaden 2026 | Lizenz, Einnahmen & Verwaltung',
      description: 'Vollständiger Leitfaden zum Start Ihres Airbnb-Geschäfts in Tokyo. Minpaku vs. Ryokan, Lizenzierungsschritte, Zeitplan, häufige Fehler, Einnahmenabschätzung und wann ein Verwaltungsservice sinnvoll ist.',
      keywords: 'Tokyo Minpaku Leitfaden, Airbnb Tokyo starten, Minpaku Lizenz, Ryokan Lizenz, Kurzzeitvermietung Tokyo',
    },
    caseStudy: {
      title: 'Ota City Minpaku Fallstudie | Tokyo Airbnb Erfolgsgeschichte',
      description: 'Echte Fallstudie: Eigentümer in Ota City startete Airbnb in 3,5 Monaten mit Ryokan-Lizenz und erzielte ¥180.000+/Monat und 78% Auslastung. Tokyo Minpaku Support in der Praxis.',
      keywords: 'Ota City Minpaku, Tokyo Airbnb Fallstudie, Ryokan Lizenz Tokyo, Airbnb Verwaltung Tokyo',
    },
    adsLanding: {
      title: 'Starten Sie Ihr Legales Airbnb-Geschäft in Tokyo | Minpaku & Ryokan Lizenz',
      description: 'Professioneller Minpaku- und Ryokan-Lizenz-Support in Tokyo. End-to-End Airbnb-Verwaltung von aktiven Gastgebern in Ota City. Kostenlose 30-Min-Beratung. Startunterstützung ab ¥300.000.',
      keywords: 'Airbnb legal Tokyo, Minpaku Lizenz Support, Ryokan Antrag Tokyo, Airbnb Start Ota City',
    },
    airbnbGuide: {
      title: 'Tokyo Airbnb Rechtsleitfaden | Vollständiger Minpaku & Ryokan Lizenzleitfaden',
      description: 'Vollständiger Leitfaden zum legalen Start von Airbnb in Tokyo. Minpaku-Registrierung, Ryokan-Lizenzanforderungen, Kosten, Zeitplan und Schritt-für-Schritt-Prozess — basierend auf echter Betriebserfahrung in Ota City.',
      keywords: 'Airbnb Tokyo Lizenz, Minpaku Registrierung Tokyo, Ryokan Lizenz Tokyo, Airbnb Verwaltung Tokyo, Kurzzeitvermietung Ota City',
    },
  },
  schema: {
    management: {
      offerDescription: '15–20 % des monatlichen Umsatzes',
      service1: 'Preisanpassung & dynamische Preisgestaltung',
      service2: 'Gästekommunikation (mehrsprachig)',
      service3: 'Bewertungsmanagement',
      service4: 'Reinigung & Wäschekoordination',
      service5: 'Monatlicher Umsatzbericht',
      service6: 'Steuererklärungshilfe-Programm',
    },
  },
  taxOffice: {
    badge: 'Steuer- & Buchhaltungsbüro',
    sectionTitle: 'Yokota Steuer- & Buchhaltungsbüro',
    sectionSubtitle: 'Minpaku-Steuerexperte in Higashi-Magome, Ota City, Tokyo',
    businessName: 'Yokota Steuer- & Buchhaltungsbüro',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'Adresse',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'Servicegebiet',
    serviceArea: 'Ota City und Groß-Tokyo',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'Anfahrt',
    accessJa: 'Toei Asakusa Linie — Bahnhof Magome',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'In Google Maps öffnen',
    supportTitle: 'Minpaku & Airbnb Steuerunterstützung',
    supportItems: [
      'Steuererklärungshilfe-System (keine Steuervertretung)',
      'Minpaku-Steuerunterstützung in Ota City',
      'Airbnb-Steuerberatung Tokyo',
      'Minpaku-Steuerunterstützung Tokyo — kostenlose Erstberatung',
      'Airbnb-Steuerberatung Tokyo — Einkommensdeklarationshilfe',
    ],
    disclaimer: '※ "Steuererklärungshilfe-System" bezeichnet die Unterstützung bei der Dokumentenvorbereitung und Beratung. Dies ist keine Steuervertretung.',
    officeImageAlt: 'Yokota Steuer- & Buchhaltungsbüro — Higashi-Magome, Ota City',
    officeImageCaption: 'Yokota Steuer- & Buchhaltungsbüro — Higashi-Magome, Ota City, Tokyo',
    officeImageSubCaption: 'Minpaku-Steuerunterstützung Ota City · Airbnb-Steuerberatung Tokyo',
  },
  managementContact: {
    title: 'Kostenloses Beratungsformular',
    name: 'Vollständiger Name',
    nameRequired: 'Pflichtfeld',
    phone: 'Telefonnummer',
    email: 'E-Mail-Adresse',
    emailRequired: 'Pflichtfeld',
    propertyType: 'Immobilientyp',
    propertyTypePlaceholder: 'Bitte auswählen',
    propertyTypeOptions: {
      mansion1k: 'Wohnung（Studio–1LDK）',
      mansion2ldk: 'Wohnung（2LDK+）',
      house: 'Einfamilienhaus',
      kominka: 'Traditionelles Haus',
      taxConsult: 'Steuerberatung',
      other: 'Sonstiges',
    },
    consultContent: 'Beratungsinhalt',
    consultContentRequired: 'Pflichtfeld',
    consultContentCounter: '{{count}}/500 Zeichen',
    consultContentPlaceholder: 'Bitte beschreiben Sie Lage, aktuellen Zustand und Ihre Wünsche（max. 500 Zeichen）',
    submit: 'Kostenlose Beratung anfragen',
    submitting: 'Wird gesendet...',
    success: 'Vielen Dank für Ihre Anfrage. Wir melden uns innerhalb von 2 Werktagen.',
    error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    beforeContact: 'Vor der Kontaktaufnahme',
    infoItems: [
      'Erstberatung vollständig kostenlos',
      'Hauptsächlich im Raum Tokyo',
      'Antwort innerhalb von 2 Werktagen',
      'Ihre Daten werden streng geschützt',
    ],
    recommendTitle: 'Wir empfehlen eine Beratung, wenn Sie…',
    recommendItems: [
      'Eine Immobilie haben, aber nicht selbst verwalten können',
      'Minpaku als Nebenerwerb starten möchten',
      'Mit Ihren aktuellen Einnahmen unzufrieden sind',
      'Einen Reinigungsservice suchen',
      'Nicht wissen, wie man Airbnb nutzt',
    ],
    confirmNote: 'Nach Bestätigung Ihrer Anfrage wird sich unser Team bei Ihnen melden.',
  },
  privateDriver: {
    badge: 'Partner Service',
    title: 'Privater Fahrer',
    titleEn: 'Private Driver Service',
    description: 'Unsere Partnerfahrer bieten professionellen Transport — vom Flughafentransfer bis zu Sightseeing-Touren.',
    descriptionHighlight: 'Englischsprachige Fahrer verfügbar.',
    featureTitle: 'Warum unser Fahrerservice',
    features: [
      { title: 'Englischsprachige Fahrer', desc: 'Englischsprachige professionelle Fahrer für internationale Gäste.' },
      { title: 'Sicher & Versichert', desc: 'Vollversicherte professionelle Fahrer garantieren sichere und komfortable Reisen.' },
      { title: '24/7 Verfügbarkeit', desc: 'Frühe Morgenflüge oder spätnächtliche Ankünfte — wir sind immer bereit.' },
      { title: 'Großes Gepäck OK', desc: 'Große Fahrzeuge für Familien verfügbar. Mehrere Koffer kein Problem.' },
      { title: 'Individuelle Routen', desc: 'Spezielle Routen zu Showa-Retro-Spots und Fotolocations auf Anfrage.' },
    ],
    menuTitle: 'Servicemenü',
    priceGuide: 'Preisübersicht',
    pricingTitle: 'Preisübersicht',
    pricingNote: 'Alle Preise inkl. MwSt. Nur Schätzungen — kontaktieren Sie uns für genaue Angebote.',
    discountBadge: 'Exklusiver Rabatt',
    discountTitle: 'Nur für Gäste',
    discountOff: '10% RABATT',
    discountSuffix: 'Sonderrabatt',
    discountNote: 'Erwähnen Sie Ihren Aufenthalt bei der Buchung, um den Rabatt zu erhalten.',
    discountBtn: 'Jetzt buchen',
    ctaBadge: 'Exklusiv für KOMINKA-Gäste',
    ctaTitle: 'Sonderpreise für Gäste',
    ctaDesc: 'KOMINKA-Gäste genießen exklusive Rabatte auf unseren privaten Fahrerservice.',
    ctaBtn: 'Fahrer buchen',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: 'Flughafentransfer', subtitle: '空港送迎', desc: 'Haneda/Narita Flughafen Abholung & Abgabe. Meet & Greet Service verfügbar.', price: 'Ab ¥8.000' },
      { title: 'Tokio Stadttour', subtitle: '東京観光ドライブ', desc: 'Erkunden Sie Showa-Viertel, Tempel und versteckte Schätze mit einem lokalen Fahrer.', price: 'Ab ¥15.000/3h' },
      { title: 'Langzeitaufenthalt Support', subtitle: '長期滞在サポート', desc: 'Wöchentlicher oder monatlicher Fahrerservice für Einkäufe und Ausflüge.', price: 'Ab ¥40.000/Woche' },
      { title: 'Fotolocations Fahrt', subtitle: '撮影ロケ送迎', desc: 'Transport zu ikonischen Showa-Spots, Retro-Einkaufsstraßen und Filmlocations.', price: 'Ab ¥12.000/2h' },
    ],
    pricing: [
      { title: 'Flughafentransfer', subtitle: 'Airport Transfer', rows: [{ label: 'Haneda Flughafen ⇔ Magome (einfach)', price: '¥8.000+' }, { label: 'Narita Flughafen ⇔ Magome (einfach)', price: '¥14.000+' }, { label: 'Nachtzuschlag (22:00–6:00)', price: '+¥2.000' }, { label: 'Großes Gepäck (3+ Koffer)', price: '+¥1.000' }], note: '* Gleicher Preis für bis zu 4 Passagiere' },
      { title: 'Tokio Stadttour', subtitle: 'Tokyo City Tour', rows: [{ label: '3-Stunden-Kurs', price: '¥15.000+' }, { label: '5-Stunden-Kurs', price: '¥22.000+' }, { label: 'Ganztag (8 Stunden)', price: '¥35.000+' }, { label: 'Showa Retro Spezialroute', price: '+¥3.000' }], note: '* Guide & Parkgebühren inklusive' },
      { title: 'Fotolocations Fahrt', subtitle: 'Photo Location Drive', rows: [{ label: '2-Stunden-Kurs', price: '¥12.000+' }, { label: '4-Stunden-Kurs', price: '¥20.000+' }, { label: 'Location-Guide Option', price: '+¥2.000' }, { label: 'Ausrüstung/Gepäck', price: '+¥1.500' }], note: '* Routenberatung im Voraus möglich' },
      { title: 'Langzeitaufenthalt Support', subtitle: 'Long Stay Support', rows: [{ label: 'Einmal pro Woche (4x/Monat)', price: '¥40.000+' }, { label: 'Zweimal pro Woche (8x/Monat)', price: '¥72.000+' }, { label: 'Einzelnutzung (3 Stunden)', price: '¥12.000+' }, { label: 'Einkaufen/Krankenhaus', price: '¥6.000+/Fahrt' }], note: '* 10% Rabatt bei monatlicher Zahlung' },
    ],
  },
};

export default common;
